// @flow
import { getCurrentRecipe, getModalVisiblePage, getTemplatesList } from '~/core/state/recipes/selectors';

import { connect } from 'react-redux';
import RecipeModal from './component';

const mapStateToProps = (
    state,
    { consumerId, producerId }
): {
    consumerId: string,
    currentPage: number,
    currentRecipe: *,
    producerId: string,
    templates: *
} => ({
    consumerId,
    currentPage: getModalVisiblePage(state) || 0,
    currentRecipe: getCurrentRecipe(state),
    producerId,
    templates: getTemplatesList(state, { consumerId, producerId })
});

export default connect(mapStateToProps)(RecipeModal);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-modal/index.js